import React, { useState, useEffect } from "react";
import { useApolloClient } from "@apollo/client";
import { useNavigate } from "react-router-dom";

const NetworkStatusMonitor = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const client = useApolloClient();
  const navigate = useNavigate();

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

 useEffect(() => {
  if (!isOnline) {
    navigate("/offline");
  } else {
    if (client) {
      client.refetchQueries({ include: "active" }).catch((error) => {
        console.error("Apollo refetchQueries error:", error);
      });
    }
  }
}, [isOnline, navigate, client]);


  return null;
};

export default NetworkStatusMonitor;
